import { Button, Col, Divider, Drawer, Form, Input, Row } from 'antd'
import React, { useEffect, useState } from 'react'
import { openNotification } from '../../../utils';
import SubjectService from '../../../services/SubjectService';
import ReactQuill from 'react-quill';
import { EditOutlined } from '@ant-design/icons'

interface SubjectUpdateProps {
    getTrigger: any;
    subjectId: number;
}

const { Item } = Form;

const SubjectUpdate: React.FC<SubjectUpdateProps> = ({ getTrigger, subjectId }) => {
    const [form] = Form.useForm();
    const [showDrawer, setShowDrawer] = useState(false);

    useEffect(() => {
        if (showDrawer) {
            getService();
        }
    }, [showDrawer]);

    const getService = () => {
        SubjectService.get(subjectId)
            .then((response: any) => {
                const data = response.data
                form.setFieldsValue({
                    name: data?.title,
                    description: data?.description,
                });
            })
            .catch((e: Error) => {
                console.log(e);
            });
    };

    const handleSubjectCreateCancel = () => {
        setShowDrawer(false);
    };

    useEffect(() => {
        form.resetFields();
    }, [showDrawer])


    const update = (values: any) => {
        let postObj: any = {
            "title": values.name,
            "description": values.description,
        };

        SubjectService.update(subjectId, postObj)
            .then((response: any) => {
                openNotification('success', 'Başarılı', 'Konu Başarıyla Düzenlendi.')
                getTrigger();
                setShowDrawer(false);
            }).catch((e: Error) => {
                openNotification('error', 'Başarısız', 'Konu Düzenlenemedi.')
                console.log(e)
            });
    }



    return (
        <>
            <Button onClick={() => setShowDrawer(true)}>
            <EditOutlined />
            </Button>
            <Drawer title="Konu Düzenle" placement="right" onClose={() => setShowDrawer(false)} open={showDrawer}>
                <Form form={form} onFinish={update} layout="vertical">
                    <Item
                        name="name"
                        label="Konu"
                        rules={[
                            {
                                required: true,
                                message: 'Konu adı zorunlu',
                            }]}
                    >
                        <Input />
                    </Item>
                    <Item
                        name="description"
                        label="Açıklama"
                    >
                        <ReactQuill className='height-150 mb-24' theme="snow" />
                    </Item>
                    <Divider></Divider>
                    <Row gutter={8}>
                        <Col span={12}>
                            <Button onClick={handleSubjectCreateCancel} className='w-full height-40'>
                                İptal
                            </Button>
                        </Col>
                        <Col span={12}>
                            <Item>
                                <Button htmlType="submit" className='w-full height-40 btn btn-hover-dark bg-saha-purple font-color-white fw-700 btn-text'>
                                    Kaydet
                                </Button>
                            </Item>
                        </Col>
                    </Row>
                </Form>
            </Drawer>
        </>
    )
}

export default SubjectUpdate